import { FieldsType, InputTypeEnum } from '../types';

export const FIELDS: FieldsType = [
  {
    id: 'pending_issues_and_approvals',
    label: 'Remarks / Comments',
    inputType: InputTypeEnum.TEXT_AREA,
  },
];
